export const spotifyCredentials = {
  ClientId: process.env.REACT_APP_SPOTIFY_CLIENT_ID,
  ClientSecret: process.env.REACT_APP_SPOTIFY_CLIENT_SECRET,
};

export const authParameters = {
  method: "POST",
  headers: {
    "Content-Type": "application/x-www-form-urlencoded",
  },
  body: `grant_type=client_credentials&client_id=${spotifyCredentials.ClientId}&client_secret=${spotifyCredentials.ClientSecret}`,
};
